
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"33","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.86 5.842c.728-1.263 2.552-1.263 3.28 0l10.575 18.316c.73 1.263-.182 2.842-1.64 2.842H5.925c-1.458 0-2.37-1.579-1.64-2.842L14.858 5.842z","fill":"#ABAFB5"}}),_c('path',{attrs:{"d":"M17.49 11.718l.002-.072h-1.98l.002.072.145 8.136v.07h1.685l.001-.07.145-8.136zm-.99 11.596a1.19 1.19 0 001.185-1.186c0-.648-.54-1.18-1.186-1.18-.652 0-1.186.533-1.186 1.18 0 .658.534 1.186 1.186 1.186z","fill":"#fff","stroke":"#fff","stroke-width":".142"}})])
          )
        }
      }
    